module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-17-79a27d2f213edd9056aaf830c2a9e788.jpg";